import React, { useEffect, useState } from "react";
import ShowToast from "components/ShowToast";

import "./Walletsettlement.css";
import { useSession } from "hooks/useSession";
import AddWalletBankAccountModal from "./components/Addwalletbankaccountmodal";
import MakeWalletPaymentModal from "./components/Makewalletpaymentmodal";
import { fetchWrapper } from "utils/apiFetch";
import PayoutReceiptModal from "Settings/Reports/PayoutReceipt";

// Mirrors the Flutter `WalletSettlement` screen:
//   - list  -> POST payout_action_manager  { action: "GET", user_id }
//   - add   -> POST payout_action_manager  { action: "ADD", bankname, account, name, ifsccode }
//   - pay   -> POST soft_payout_transaction { transection_mode, userid, account_number, ifsc_code, holder_name, bank_name, remark, amount, lat, long }
const Cashout = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptId, setReceiptId] = useState(null);


  const { userid } = useSession();

  useEffect(() => {
    fetchSettlementList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSettlementList = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "GET");
      formData.append("user_id", userid);

      const res = await fetchWrapper("https://pro.mokshiq.in/payout_action_manager", {
        method: "POST",
        body: formData,
      });

      // backend returns { data: [{ account, IFSC_Code, name, Bank_Name }], status }
      setList(res?.data || []);
    } catch (e) {
      ShowToast("Failed to load settlement accounts", "danger");
    } finally {
      setLoading(false);
    }
  };
  const handleView = (row) => {
    setSelectedRow(row);
    setShowReceipt(true);
  };

  const handleCloseReceipt = () => {
    setShowReceipt(false);
    setSelectedRow(null);
  };

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-10">
            <h4 className="main-title">Wallet Settlement</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Wallet Settlement
                </a>
              </li>
            </ul>
          </div>
          <div className="col-2 d-flex gap-2 justify-content-end">
            <button className="add-btn" onClick={() => setShowAddModal(true)}>
              Add Account
            </button>
          </div>
        </div>

        <div className="wallet-page">
          {loading ? (
            <div className="loader">Loading...</div>
          ) : list.length === 0 ? (
            <div className="empty-state">No settlement accounts added</div>
          ) : (
            <div className="wallet-grid">
              {list.map((item, index) => (
                <div className="wallet-card" key={`${item.account}-${index}`}>
                  <div className="card-header">
                    <h5>{item.Bank_Name}</h5>
                  </div>

                  <div className="card-body">
                    <div className="info-row">
                      <span>Account Holder</span>
                      <b>{item.name}</b>
                    </div>
                    <div className="info-row">
                      <span>Account No</span>
                      <b>{item.account}</b>
                    </div>
                    <div className="info-row">
                      <span>IFSC</span>
                      <b>{item.IFSC_Code}</b>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      className="btn primary"
                      onClick={() => {
                        setSelectedRow(item);
                        setShowPayModal(true);
                      }}
                    >
                      Settle Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Add Account Modal */}
          <AddWalletBankAccountModal
            show={showAddModal}
            onClose={() => setShowAddModal(false)}
            onSuccess={fetchSettlementList}
          />

          {/* Make Payment Modal */}
          {selectedRow && showPayModal && (
            <MakeWalletPaymentModal
              key={selectedRow.account}
              show={showPayModal}
              onClose={() => {
                setShowPayModal(false);
                setSelectedRow(null);
              }}
              userData={selectedRow}
              onSuccess={(referenceNum) => {
                setShowPayModal(false);
                setSelectedRow(null);
                fetchSettlementList();

                // MakeWalletPaymentModal already confirmed status === true
                // and calls onSuccess(res.reference_num) — just the string.
                if (referenceNum) {
                  setReceiptId(referenceNum);
                  setShowReceipt(true);
                } else {
                  ShowToast("Payment succeeded but no reference number was returned", "warning");
                }
              }}
            />
          )}
        </div>
        <PayoutReceiptModal
          isOpen={showReceipt}
          onClose={() => setShowReceipt(false)}
          payoutId={receiptId}  // or receiptData={selectedRow} if the row already has full data
        />

      </div>

    </main>
  );
};

export default Cashout;